export const price =[
    {"name": "Below ₹500", "min": 0, "max": 500, value:"500"},
    {"name": "₹500 - ₹1000", "min": 500, "max": 1000, value:"500 - 1000"},
    {"name": "₹1000 - ₹2000", "min": 1000, "max": 2000, value:"1000 - 2000"},
    {"name": "₹2000 - ₹3000", "min": 2000, "max": 3000, value:"2000 - 3000"},
    {"name": "₹3000 - ₹5000", "min": 3000, "max": 5000, value:"3000 - 5000"},
    {"name": "₹5000 - ₹10000", "min": 5000, "max": 10000, value: "5000 - 10000"},
    {"name": "₹10000 and above", "min": 10000, "max": null, value:"10000"}
  ]
  